__turbopack_context__.v({
  "bannerWrapper": "HeaderBanner-module-scss-module__VlrOuq__bannerWrapper",
  "centeredBannerContainer": "HeaderBanner-module-scss-module__VlrOuq__centeredBannerContainer",
  "centeredTextWrapper": "HeaderBanner-module-scss-module__VlrOuq__centeredTextWrapper",
  "mobileView": "HeaderBanner-module-scss-module__VlrOuq__mobileView",
  "subtitle": "HeaderBanner-module-scss-module__VlrOuq__subtitle",
  "textWrapper": "HeaderBanner-module-scss-module__VlrOuq__textWrapper",
});
